import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Bides.css";

function Bid() {
  const [bids, setBids] = useState([]);
  const [title, setTitle] = useState("");
  const [bidType, setBidType] = useState("furniture");
  const [startingBid, setStartingBid] = useState("");
  const [location, setLocation] = useState("");
  const [image, setImage] = useState(null);

  // Fetch bids when the component mounts
  useEffect(() => {
    axios
      .get("http://localhost:5000/bids")
      .then((response) => {
        setBids(response.data);
      })
      .catch((error) => {
        console.error("Error fetching bids:", error);
      });
  }, []);

  // Handle form submission for creating a new bid
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("bidType", bidType);
    formData.append("startingBid", startingBid);
    formData.append("location", location);
    if (image) formData.append("image", image);

    axios
      .post("http://localhost:5000/bids", formData)
      .then((response) => {
        // Add the new bid to the state
        setBids([response.data, ...bids]);
        setTitle("");
        setBidType("furniture");
        setStartingBid("");
        setLocation("");
        setImage(null);
      })
      .catch((error) => {
        console.error("Error posting bid:", error);
      });
  };

  // Handle image file change
  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  return (
    <div className="App">
      {/*<h1>Bids</h1>
      <h2>Add a New Bid</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title: </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Bid Type: </label>
          <select
            value={bidType}
            onChange={(e) => setBidType(e.target.value)}
            required
          >
            <option value="furniture">Furniture</option>
            <option value="electronics">Electronics</option>
            <option value="stationary">Stationary</option>
            <option value="spare parts">Spare Parts</option>
          </select>
        </div>
        <div>
          <label>Starting Bid: </label>
          <input
            type="number"
            value={startingBid}
            onChange={(e) => setStartingBid(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Location: </label>
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Image: </label>
          <input type="file" onChange={handleImageChange} />
        </div>
        <button type="submit">Post Bid</button>
      </form>
      {/* Displaying the list of bids */}
      <h2>Available Bids</h2>
      <ul>
        {bids.length > 0 ? (
          bids.map((bid) => (
            <li key={bid.id}>
              <h3>{bid.title}</h3>
              <p>
                <strong>Bid Type:</strong> {bid.bidType}
              </p>
              <p>
                <strong>Starting Bid:</strong> ${bid.startingBid}
              </p>
              <p>
                <strong>Location:</strong> {bid.location}
              </p>
              <p>
                <strong>Date posted:</strong>{" "}
                {new Date(bid.order_date).toLocaleString()}
              </p>
              {bid.image && (
                <img
                  src={`http://localhost:5000/${bid.image}`}
                  alt="Bid"
                  style={{ width: "200px", height: "200px" }}
                />
              )}
            </li>
          ))
        ) : (
          <p>No bids available at the moment.</p>
        )}
      </ul>
    </div>
  );
}

export default Bid;
